<template>
    <div class="gallery-overlay grid">
        <div class="grid--row  gallery-overlay--row">
            <div class="grid--col gallery-overlay--col">
                <cmp-carousel :items="plugins"
                        facet="gallery-overlay"
                        :show-arrows="true"
                        :show-pagination="false"
                        :show-item-count="true"
                        :passive-mode="false"
                        :preload-range="1"
                        :allow-arrow-keys="true"
                        :idx="idx">
                    <template slot="item" slot-scope="props">
                        <div class="gallery-overlay--carousel-item grid">
                            <component facet="gallery-overlay"
                                    :is="props.item.type"
                                    :plugin="props.item"
                                    :preload="props.isActive"
                                    resource-name="image">
                            </component>
                        </div>
                    </template>
                </cmp-carousel>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            idx: Number,
            plugins: Array,
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?11c57eab